// Shared state for the "framing tip" card that surfaces on the photo +
// video capture screens (transformation flows only). The card is a
// small heads-up about which half the shot will land in and what frame
// chrome to avoid; once the barber has seen it a few times the value
// drops, so we let them dismiss it permanently via the close button.
//
// LocalStorage rather than the user profile because: (a) the tip is
// purely cosmetic — losing it across devices doesn't break the flow,
// (b) it's a per-device habit ("I already know on this phone"), and
// (c) no migration cost.

const STORAGE_KEY = 'bb.framingTipDismissed.v1';

/** Read the user's dismissal preference. SSR-safe — returns false
 *  if window/localStorage is unavailable. */
export function isFramingTipDismissed(): boolean {
  try {
    if (typeof window === 'undefined') return false;
    return window.localStorage.getItem(STORAGE_KEY) === '1';
  } catch {
    // Private-mode Safari etc — fall through to "not dismissed" so the
    // tip still surfaces; worst case the barber dismisses it every
    // session, which is annoying but not broken.
    return false;
  }
}

/** Persist the dismissal so the tip never shows on this device again
 *  (until a v1.2 bump of STORAGE_KEY revives it). */
export function dismissFramingTip(): void {
  try {
    if (typeof window === 'undefined') return;
    window.localStorage.setItem(STORAGE_KEY, '1');
  } catch {
    /* ignore */
  }
}
